"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.elapse = exports.attemptDebounce = exports.howLongAgo = exports.dateLocalizer = exports.throttle = exports.debounce = exports.DEFAULT_DEBOUNCE_TIME = exports.ms_per_s = exports.ms_per_min = void 0;
var asyncToGenerator_1 = __importDefault(require("@babel/runtime/helpers/esm/asyncToGenerator"));
var toConsumableArray_1 = __importDefault(require("@babel/runtime/helpers/esm/toConsumableArray"));
var regenerator_1 = __importDefault(require("@babel/runtime/regenerator"));
var dayjs_1 = __importDefault(require("dayjs"));
require("dayjs/locale/nb");
var localizedFormat_1 = __importDefault(require("dayjs/plugin/localizedFormat"));
var utc_1 = __importDefault(require("dayjs/plugin/utc"));
var relativeTime_1 = __importDefault(require("dayjs/plugin/relativeTime"));
dayjs_1.default.extend(localizedFormat_1.default);
dayjs_1.default.extend(utc_1.default);
dayjs_1.default.extend(relativeTime_1.default); // NOTE: these are pragmatically snake cased, because of SI units being case sensitive while we want short names
exports.ms_per_min = 60e3;
exports.ms_per_s = 1e3;
var DOHERTY_THRESHOLD = 400e-3;
var ESTIMATED_API_RESPONSE_TIME_UPPER_BOUND = 50e-3;
exports.DEFAULT_DEBOUNCE_TIME = DOHERTY_THRESHOLD - ESTIMATED_API_RESPONSE_TIME_UPPER_BOUND;
var debounce = function debounce(f) {
    var t;
    return function (debounceTime) {
        return function () {
            for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
                args[_key] = arguments[_key];
            }
            clearTimeout(t);
            t = setTimeout(function () {
                f.apply(void 0, args);
            }, debounceTime * exports.ms_per_s);
        };
    };
};
exports.debounce = debounce;
var throttle = function throttle(f) {
    var t = null;
    var invocationArgs;
    return function (throttleTime) {
        return function () {
            for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
                args[_key2] = arguments[_key2];
            }
            invocationArgs = args;
            if (!t) {
                t = setTimeout(function () {
                    t = null;
                    f.apply(void 0, toConsumableArray_1.default(invocationArgs));
                }, throttleTime * exports.ms_per_s);
            }
        };
    };
};
exports.throttle = throttle;
var localize = function localize(localeCode) {
    return function (dayjsDate) {
        return dayjsDate.locale(localeCode);
    };
};
var formatYear = function formatYear(dayjsDate) {
    return dayjsDate.format('D. MMMM YYYY');
};
var formatDateTimeWithSeconds = function formatDateTimeWithSeconds(dayjsDate) {
    return dayjsDate.format('YYYY-MM-DD HH:mm:ss');
};
var convert = function convert(date) {
    return dayjs_1.default(date).utc(true).local();
};
var dateLocalizer = function dateLocalizer(localeCode) {
    return {
        convert: convert,
        now: function now() {
            return convert(undefined);
        },
        format: {
            year: formatYear,
            dateTimeWithSeconds: formatDateTimeWithSeconds
        },
        localize: localize(localeCode)
    };
};
exports.dateLocalizer = dateLocalizer;
var howLongAgo = function howLongAgo(date) {
    return dayjs_1.default().locale('nb').to(date);
};
exports.howLongAgo = howLongAgo;
/**
 * Attempts completion of a debounce.
 *
 * ```js
 * const completed = await attemptDebounce(ctx, debounceTime)
 * if (completed) {
 *   ... // do your thing!
 * }
 * ```
 *
 * @param {object} ctx will be used to store `timeout` and `resolve` for successive calls.
 * Note that this object may differ each invocation as long as the previously stored properties
 * are passed inside the next call on `ctx`
 * @param {number} debounceTime in seconds
 * @returns {boolean} true when debounce completes, false otherwise
 */
exports.attemptDebounce = function () {
    var _ref = asyncToGenerator_1.default(/*#__PURE__*/ regenerator_1.default.mark(function _callee(ctx, debounceTime) {
        return regenerator_1.default.wrap(function _callee$(_context) {
            while (1) {
                switch (_context.prev = _context.next) {
                    case 0:
                        if (ctx.timeout) {
                            clearTimeout(ctx.timeout);
                            ctx.resolve(false);
                        }
                        return _context.abrupt("return", new Promise(function (resolve) {
                            ctx.resolve = resolve;
                            ctx.timeout = setTimeout(function () {
                                ctx.resolve = null;
                                ctx.timeout = null;
                                resolve(true);
                            }, debounceTime * exports.ms_per_s);
                        }));
                    case 2:
                    case "end":
                        return _context.stop();
                }
            }
        }, _callee);
    }));
    return function attemptDebounce(_x, _x2) {
        return _ref.apply(this, arguments);
    };
}();
exports.elapse = function () {
    var _ref2 = asyncToGenerator_1.default(/*#__PURE__*/ regenerator_1.default.mark(function _callee2(time) {
        return regenerator_1.default.wrap(function _callee2$(_context2) {
            while (1) {
                switch (_context2.prev = _context2.next) {
                    case 0:
                        return _context2.abrupt("return", new Promise(function (resolve) {
                            return setTimeout(resolve, time * exports.ms_per_s);
                        }));
                    case 1:
                    case "end":
                        return _context2.stop();
                }
            }
        }, _callee2);
    }));
    return function elapse(_x3) {
        return _ref2.apply(this, arguments);
    };
}();
